/*!
 * DM Offer Templates - Version: 1.1.17
 * Indeed - Copyright (c) 2023
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

$( document ).ready(function() {
    $('#submit-id-submit').click(function()	{
        window.location='https://www.indeed.com/jobs?q=' + $('#id_what').val() + '&l=' + $('#id_where').val() + '&from=profilelpcreateresume';
    });
});
function getCookie(name) {
    const nameWithSeparator = name + "=";
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();

        if (cookie.indexOf(nameWithSeparator) === 0) {
            return cookie.substring(nameWithSeparator.length, cookie.length);
        }
    }

    return null;
}
function getGnavConfig() {
    const gnavConfigElement = document.getElementById("_indeed_gnav_config");

    if (gnavConfigElement !== null) {
        const gnavConfig = JSON.parse(gnavConfigElement.textContent);
        return gnavConfig;
    }

    return null;
}
function isUserLoggedIn() {
    const gnavConfig = getGnavConfig();

    if (gnavConfig !== null && gnavConfig.hasOwnProperty("isLoggedIn")) {
        return gnavConfig.isLoggedIn;
    }

    return getCookie("SHOE") !== null || getCookie("SOCK") !== null;
}
function isReturningUser() {
    return getCookie("ADV") === "1";
}
function isNewUser() {
    return !(isUserLoggedIn() || isReturningUser());
}
function getLocale() {
    const gnavConfig = getGnavConfig();

    if (gnavConfig !== null && gnavConfig.hasOwnProperty("language")) {
        return { hl: gnavConfig.language, co: gnavConfig.country || "US" };
    }
    const pageWrapElement = document.getElementById("pageWrap");
    if (pageWrapElement && pageWrapElement.className.trim() !== "") {
        const locale = pageWrapElement.className.split(" ")[0]; 
        const twoOrFourLetterLocaleRegex = /^(([a-zA-Z]{2}_[a-zA-Z]{2})|[a-zA-Z]{2})$/;

        if (twoOrFourLetterLocaleRegex.test(locale)) {
            const hl = locale.split("_")[0];
            const co = locale.split("_")[1] || "US";

            return { hl: hl, co: co };
        }
    }

    return { hl: "en", co: "US" };
}
function isProductionEnvironment() {
    const gnavConfig = getGnavConfig();

    if (gnavConfig !== null) {
        return !gnavConfig.isPreproduction;
    }

    const host = window.location.hostname;

    return !host.includes(".qa.indeed.net");
}
function setupModalCloseListeners() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");

    [].forEach.call(nopassModalWrapper.querySelectorAll(".nopass-close-button, .nopass-modal-overlay"), function (el) {
        el.addEventListener("click", function () {
            nopassModalWrapper.classList.add("hide-nopass");

            const companyName = document.getElementById("companyname");
            companyName.value = "";
            companyName.parentElement.classList.remove("nopass-text-input-wrapper--has-error");

            const email = document.getElementById("email");
            email.value = "";
            email.parentElement.classList.remove("nopass-text-input-wrapper--has-error");
            document.getElementById("label-no-companyname-error") && document.getElementById("label-no-companyname-error").classList.add("hide-nopass");
            document.getElementById("label-no-email-error") && document.getElementById("label-no-email-error").classList.add("hide-nopass");
            document.getElementById("label-invalid-email-error") && document.getElementById("label-invalid-email-error").classList.add("hide-nopass");

            clearAutocomplete();
        });
    });
}
function setupModalFocusTrap() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const focusableElements = nopassModalWrapper.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    nopassModalWrapper.addEventListener("keydown", function(e) {
        if (e.key === "Tab") {
            if (e.shiftKey) { 
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        }
    });
}
function updateLocalesInLinksAndAttributes(hl, co) {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    [].forEach.call(nopassModalWrapper.querySelectorAll("#nopass-tos-link, #nopass-cookie-policy-link, #nopass-privacy-policy-link"), function (el) {
        el.href = el.href.replace("en", hl);
    });
    nopassModalWrapper.querySelector('[name="hl"]').value = hl;
    nopassModalWrapper.querySelector('[name="co"]').value = co;

    nopassModalWrapper.querySelector("#nopass-sign-in-link").href +=
        "?hl=" + hl +
        "&co=" + co +
        "&continue=" + encodeURIComponent(location.protocol + location.hostname + location.pathname);
}
function buildBaseContinueUrlWithTrackingParams(hrefComponents, hl, co) {
    const fromParam = hrefComponents.from !== null
        ? "&from=" + hrefComponents.from
        : "";
    const isidParam = hrefComponents.isid !== null
        ? "&isid=" + hrefComponents.isid
        : "";
    const ikwParam = hrefComponents.ikw !== null
        ? "&ikw=" + hrefComponents.ikw
        : "";

    const continueUrlWithTrackingParams = hrefComponents.baseContinueUrl +
        '?hl=' + hl +
        "&co=" + co +
        fromParam +
        isidParam +
        ikwParam +
        "&trafficTk=" + getCookie("CTK") +
        "&sid=" + location.hostname +
        "&kw=" + encodeURIComponent(location.pathname);

    return continueUrlWithTrackingParams;
}
function buildFinalContinueUrlWithCompanyNameParamIfNeeded(baseContinueUrlWithTrackingParams, companyName) {
    const url = new URL(baseContinueUrlWithTrackingParams);

    let prepopulateWithParam = "";
    if (["/o/p", "/p", "/p/post-job", "/j/post-job", "/build-jd"].some(ctaDestinationPath => url.pathname === ctaDestinationPath)) {
        prepopulateWithParam = "&prepopulateWith=" + encodeURIComponent('{"advertiserCompany":"' + companyName + '"}');
    }

    const finalContinueUrlWithQueryParams = baseContinueUrlWithTrackingParams +
        "&jstm=" + new Date().getTime().toString() +
        prepopulateWithParam;

    return finalContinueUrlWithQueryParams;
}
let autocompleteCore = null;
let currentSeqId = 0;
let lastSeenSeqId = 0;
function setupAutocompleteCore() {
    const locale = getLocale();
    const hl = locale.hl;
    const co = locale.co;
    const autocompleteEndpoint = isProductionEnvironment()
        ? "https://autocomplete.indeed.com/api/v0"
        : "https://autocomplete.sandbox.qa.indeed.net/api/v0";
    const config = {
        type: "company", 
        country: co, 
        language: hl, 
        count: 5, 
        enableEmptyQuery: true,
        page: "post-press", 
        useEachWord: true,
        showAlternateSuggestions: false,
        recentQueryCount: 2,
        recentQuery: [],
        dedupeRecentQueryResultsCaseInsensitively: false,
        userIdentifiers: { 
            ctk: getCookie("CTK")
        },
        submitOnSelected: false,
        debounce: true,
        debounceTimeoutInMs: 200,
        minimumQueryLength: 0,
        rich: false,
        endpoint: autocompleteEndpoint,
        prioritizeExactMatch: true,
    };
    autocompleteCore = new AutocompleteCore(config);
}
function getSuggestions(query, successCallback, errorCallback) {
    if (typeof autocompleteCore === 'undefined' || !autocompleteCore) {
        console.error('Autocomplete Core has not been initialized yet.');
        return;
    }

    currentSeqId = currentSeqId + 1;
    autocompleteCore.getSuggestions(
        query,
        currentSeqId,
        (seqId, suggestions, _) => { 
            if (seqId > lastSeenSeqId) {
                lastSeenSeqId = seqId;
                const companyNames = suggestions.map(suggestion => suggestion.suggestion);
                successCallback(companyNames);
            }
        },
        (seqId, error) => {
            if (seqId > lastSeenSeqId) {
                lastSeenSeqId = seqId;
                errorCallback(error);
            }
        }
    );
}
function clearAutocomplete() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const autoComplete = nopassModalWrapper.querySelector(".nopass-autocomplete");
    nopassModalWrapper.querySelector(".nopass-autocomplete-list") &&
    (autoComplete.classList.remove("is-open"),
        nopassModalWrapper.querySelectorAll(".nopass-autocomplete-list").forEach(el => el.remove()),
        nopassModalWrapper.querySelectorAll(".nopass-autocomplete-aria-results-available-wrapper").forEach(el => el.remove()));
    window.currentAutocompleteOptionIndex = -1;
}
function updateAutocompleteOptionIndexForKeyboardNavigation(companyNames, isDownKey) {
    const indexOffset = isDownKey
        ? 1
        : -1;
    if (window.currentAutocompleteOptionIndex + indexOffset >= companyNames.length) {
        window.currentAutocompleteOptionIndex = -1;
    } else if (window.currentAutocompleteOptionIndex + indexOffset < -1) {
        window.currentAutocompleteOptionIndex = companyNames.length - 1;
    } else {
        window.currentAutocompleteOptionIndex += indexOffset;
    }
}
function setupAutocompleteKeyboardNavigation() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const autoComplete = nopassModalWrapper.querySelector(".nopass-autocomplete");
    const companyName = nopassModalWrapper.querySelector("#companyname");

    companyName.addEventListener("keydown", function (e) {
        const isDownKey = e.key === "ArrowDown";
        const isUpKey = e.key === "ArrowUp";
        const isEnterKey = e.key === "Enter";
        const isEscapeKey = e.key === "Escape";
        const isTabKey = e.key === "Tab";

        const companyNames = nopassModalWrapper.querySelectorAll(".nopass-autocomplete-option"); 

        if (companyName.value && isEscapeKey) { 
            companyName.value = window.currentCompanyNameUserInput;
            clearAutocomplete();
            return;
        } else if (isEnterKey || isTabKey) { 
            const currentlySelectedAutocompleteOption = nopassModalWrapper.querySelector(".nopass-autocomplete-option.has-focus");

            if (currentlySelectedAutocompleteOption) {
                window.currentCompanyNameUserInput = currentlySelectedAutocompleteOption.textContent.trim();
            }

            clearAutocomplete();
            return;
        } else if (!autoComplete.classList.contains("is-open") && (isDownKey || isUpKey)) { 
            return;
        } else if ((!companyNames || !companyNames.length) || (!isUpKey && !isDownKey)) { 
            return;
        }

        e.preventDefault();

        updateAutocompleteOptionIndexForKeyboardNavigation(companyNames, isDownKey);

        [].forEach.call(nopassModalWrapper.querySelectorAll(".nopass-autocomplete-option.has-focus"), function (el) {
            el.classList.remove("has-focus");
        });

        if (window.currentAutocompleteOptionIndex === -1) {
            companyName.value = window.currentCompanyNameUserInput; 
        } else if (window.currentAutocompleteOptionIndex >= 0) {
            const currentlySelectedAutocompleteOption = nopassModalWrapper.querySelectorAll(".nopass-autocomplete-option")[window.currentAutocompleteOptionIndex];
            currentlySelectedAutocompleteOption.classList.add("has-focus");
            companyName.value = currentlySelectedAutocompleteOption.textContent.trim();
        }
    });
}
function setupAutocompleteOnChangeEventListeners() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const companyName = nopassModalWrapper.querySelector("#companyname");

    ["input", "paste"].forEach(function (event) {
        companyName.addEventListener(event, function () {
            clearAutocomplete();

            if (!companyName.value) {
                companyName.parentElement.classList.add("nopass-text-input-wrapper--has-error");
                document.getElementById("label-no-companyname-error") && document.getElementById("label-no-companyname-error").classList.remove("hide-nopass");
            } else {
                companyName.parentElement.classList.remove("nopass-text-input-wrapper--has-error");
                document.getElementById("label-no-companyname-error") && document.getElementById("label-no-companyname-error").classList.add("hide-nopass");

                window.currentCompanyNameUserInput = companyName.value;

                getSuggestions(
                    companyName.value,
                    (companyNames) => {
                        if (companyNames.length) {
                            const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
                            const companyName = nopassModalWrapper.querySelector("#companyname");
                            const autoComplete = nopassModalWrapper.querySelector(".nopass-autocomplete");
                            autoComplete.classList.add("is-open");

                            let list = '<ul class="nopass-autocomplete-list" role="listbox">';

                            companyNames.forEach(function (el) {
                                const item =
                                    '<li role="option" class="nopass-autocomplete-option">' +
                                    '  <span class="nopass-autocomplete-text">' +
                                    '    <span>' + el + '</span>' +
                                    '  </span>' +
                                    '</li>';
                                list += item;
                            });

                            list +=
                                '</ul>' +
                                '<div class="nopass-autocomplete-aria-results-available-wrapper">' +
                                '  <span aria-live="polite" aria-atomic="true" role="status" class="nopass-autocomplete-aria-results-available">' + companyNames.length + ' undefined</span>' +
                                '</div>';

                            autoComplete.insertAdjacentHTML("beforeend", list);

                            [].forEach.call(nopassModalWrapper.querySelectorAll(".nopass-autocomplete-option"), function (el) {
                                el.addEventListener("click", function () {
                                    companyName.value = el.textContent.trim();
                                    window.currentCompanyNameUserInput = companyName.value;
                                    clearAutocomplete();
                                });
                            });
                        }
                    },
                    (error) => {
                        console.error("Something went wrong while fetching company names for autocompletion: ", error);
                    }
                );
            }
        });
    });
}
function setupCompanyNameAutocomplete() {
    window.currentAutocompleteOptionIndex = -1; 
    window.currentCompanyNameUserInput = ""; 

    setupAutocompleteKeyboardNavigation();
    setupAutocompleteOnChangeEventListeners();
}
function setupEmailValidationListener() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const email = nopassModalWrapper.querySelector("#email");

    ["input", "paste"].forEach(function (event) {
        email.addEventListener(event, function () {
            document.getElementById("label-no-email-error") && document.getElementById("label-no-email-error").classList.add("hide-nopass");
            document.getElementById("label-invalid-email-error") && document.getElementById("label-invalid-email-error").classList.add("hide-nopass");

            if (!email.value) {
                email.parentElement.classList.add("nopass-text-input-wrapper--has-error");
                document.getElementById("label-no-email-error") && document.getElementById("label-no-email-error").classList.remove("hide-nopass");
            } else if (
                !/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/.test(
                    email.value
                )
            ) {
                email.parentElement.classList.add("nopass-text-input-wrapper--has-error");
                document.getElementById("label-invalid-email-error") && document.getElementById("label-invalid-email-error").classList.remove("hide-nopass");
            } else {
                email.parentElement.classList.remove("nopass-text-input-wrapper--has-error");
                document.getElementById("label-no-email-error") && document.getElementById("label-no-email-error").classList.add("hide-nopass");
                document.getElementById("label-invalid-email-error") && document.getElementById("label-invalid-email-error").classList.add("hide-nopass");
            }
        });
    });
}
function enableSubmitButtonIfInputsAreValid() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const inputs = nopassModalWrapper.querySelectorAll(".nopass-text-input-control");
    [].forEach.call(inputs, function (input) {
        ["input", "paste"].forEach(function (event) {
            input.addEventListener(event, function () {
                if (
                    [].every.call(inputs, function (el) {
                        return el.value;
                    }) &&
                    !nopassModalWrapper.querySelectorAll(".nopass-text-input-wrapper--has-error").length
                )
                    nopassModalWrapper.querySelector("#continueButton").removeAttribute("disabled");
                else {
                    nopassModalWrapper.querySelector("#continueButton").setAttribute("disabled", true);
                }
            });
        });
    });
}
function parseHref(href) {
    const url = new URL(href);
    const hostname = isProductionEnvironment()
        ? url.hostname
        : url.hostname.replace(".indeed.com", ".qa.indeed.net");

    const baseContinueUrl = url.protocol + "//" + hostname + url.pathname + url.hash; 
    const from = url.searchParams.get("from");
    const isid = url.searchParams.get("isid");
    const ikw = url.searchParams.get("ikw");

    return { baseContinueUrl: baseContinueUrl, from: from, isid: isid, ikw: ikw };
}
function setupBuildingFinalContinueUrlOnFormSubmit(cta, hl, co) {
    const href = cta.href
        || document.querySelector("." + cta.className.replaceAll(" ", ".") + ">a")
        || "https://employers.indeed.com/p/post-job";
    const hrefComponents = parseHref(href);

    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    nopassModalWrapper.querySelector(".account-creation").addEventListener("submit", function () {
        const companyName = nopassModalWrapper.querySelector("#companyname").value;
        const baseContinueUrlWithTrackingParams = buildBaseContinueUrlWithTrackingParams(hrefComponents, hl, co);
        const finalContinueUrl = buildFinalContinueUrlWithCompanyNameParamIfNeeded(baseContinueUrlWithTrackingParams, companyName);
        nopassModalWrapper.querySelector('[name="postJobURL"]').value = finalContinueUrl; 
    });
}
function setupNopassModalBehaviorIfNeeded() {
    if (!isNewUser() || document.getElementById("nopass-modal-wrapper") === null) {
        console.debug(`Skipping NoPass setup.
        --> User is logged in: ${isUserLoggedIn()}
        --> Returning user: ${isReturningUser()}
        --> New user: ${isNewUser()}
        --> Modal wrapper is null at time of Javascript running: ${document.getElementById("nopass-modal-wrapper") === null}
        --> Document at time of Javascript running: `, document
        );
        return;
    }

    setupModalCloseListeners();
    setupModalFocusTrap();

    const locale = getLocale();
    const hl = locale.hl;
    const co = locale.co;
    updateLocalesInLinksAndAttributes(hl, co);

    setupCompanyNameAutocomplete();
    setupEmailValidationListener();
    enableSubmitButtonIfInputsAreValid();
    const ctas = document.querySelectorAll(".smb-cta-btn.has-destination-url, .dm-offer-cta-btn.has-destination-url");
    ctas.forEach(cta => cta.addEventListener("click", function (e) {
        e.preventDefault();
        const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
        nopassModalWrapper.classList.remove("hide-nopass");
        const companyName = nopassModalWrapper.querySelector("#companyname");
        companyName.focus();
        setupBuildingFinalContinueUrlOnFormSubmit(cta, hl, co);
    }));
}

window.addEventListener('AutocompleteLoaded', setupAutocompleteCore);
window.addEventListener('load', setupNopassModalBehaviorIfNeeded);

if (typeof appendParamsOnce !== 'function') {
    window.appendParamsOnce = function (url, params) {
        const useParams = params.replace(/^(\?|\&)/, '');
        const anchorRegExp = new RegExp(/#.*$/);
        const urlAnchorMatch = url.match(anchorRegExp);

        const anchor = urlAnchorMatch == null ? '' : urlAnchorMatch;
        url = url.replace(anchorRegExp, '');

        if (url.match(new RegExp('[\\?|\\&]' + regExpEscape(useParams))) == null) {
            url += (url.indexOf('?') > 0 ? '&' : '?') + useParams;
        }
        url += anchor;

        return url;
    };
}

if (typeof regExpEscape !== 'function') {
    window.regExpEscape = function (s) {
        return String(s).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\\$1').replace(/\x08/g, '\\x08');
    };
}

const EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY = 'exit-modal-do-not-show';
const EXIT_MODAL_SHOW_ONCE_COOKIE_KEY = 'EXIT_MODAL_ALREADY_SHOWN';
const EXIT_MODAL_SHOW_ONCE_COOKIE_TTL = 300000; 
const MOBILE_INACTIVITY_POLLING_MS = 1000; 
const DESKTOP_DELAY_MS = 1000; 
function setExitModalShownCookie() {
    const now = new Date();
    const currentTime = now.getTime();
    now.setTime(currentTime + EXIT_MODAL_SHOW_ONCE_COOKIE_TTL);
    document.cookie = `${EXIT_MODAL_SHOW_ONCE_COOKIE_KEY}=true;expires=${now.toUTCString()};path=/`;
}

function deleteExitModalShownCookie() {
    document.cookie = `${EXIT_MODAL_SHOW_ONCE_COOKIE_KEY}=false;expires=${new Date(0).toUTCString()};path=/`;
}

function checkIfExitModalShownCookieExists() {
    return document.cookie.split(';')
        .some((cookie) => cookie.trim().startsWith(`${EXIT_MODAL_SHOW_ONCE_COOKIE_KEY}=`));
}
function calculateExitModalStatusForContentTemplates() {
    if (typeof exitModalQueryParameters !== 'undefined') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.keys(Object.fromEntries(urlSearchParams.entries()));
        const hasMatchingQueryParam = params.some(param => exitModalQueryParameters.has(param.toLowerCase()));

        if (hasMatchingQueryParam) {
            return true;
        }
    }

    return false;
}

function setupExitModal() {
    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    document.body.insertBefore(exitModalWrapper, document.body.firstChild);

    setupExitModalFocusTrap();

    document.querySelector('.exit-modal-close').addEventListener('click', () => {
        deleteExitModalShownCookie();
        sessionStorage?.setItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY, 'true');
        document.querySelector('.exit-modal-wrapper').classList.add('hide-me');
    });
}

function displayExitModal() {
    setExitModalShownCookie();

    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    exitModalWrapper.classList.remove('hide-me');
    exitModalWrapper.focus();
    try {
        turnstile.turn(exitModalWrapper, {'data-tn-action': 'impression'});
        console.debug('Turnstile event fired for exit modal view.');
    } catch (error) {
        console.error('Failed to fire Turnstile event for exit modal view: ', error);
    }
}
function setupExitModalFocusTrap() {
    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    const focusableElements = exitModalWrapper.querySelectorAll("a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled])");
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    exitModalWrapper.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
            if (e.shiftKey) { 
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        }
    });
}

window.addEventListener('DOMContentLoaded', () => {
    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    if (!exitModalWrapper) {
        return;
    }

    if (isContentTemplate) {
        const shouldEnableExitModalForContentTemplates = calculateExitModalStatusForContentTemplates();

        if (!shouldEnableExitModalForContentTemplates) {
            console.debug('Disabling exit modal for Content template.');
            document.querySelector('.exit-modal-wrapper').remove();
            return;
        }
        console.debug('Leaving exit modal enabled for Content template based on existence of a query parameter.');
    }

    setupExitModal();
    if (
        ('userAgentData' in navigator && navigator.userAgentData.mobile) 
        || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0) 
        || ('msMaxTouchPoints' in navigator && navigator.msMaxTouchPoints > 0) 
        || matchMedia?.('(pointer:coarse)') && matchMedia?.('(pointer:coarse)')?.media === '(pointer:coarse)' 
        || 'orientation' in window 
        || (/Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini/i.test(navigator.userAgent)) 
    ) {
        let idleTimer = 0;
        ['touchstart', 'touchmove', 'click'].forEach((eventType) => document.addEventListener(eventType, () => idleTimer = 0));

        setInterval(() => {
            idleTimer++;

            if (idleTimer >= 10 
                && !sessionStorage?.getItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY) 
                && exitModalWrapper.classList.contains('hide-me')
            ) {
                displayExitModal();
            }
        }, MOBILE_INACTIVITY_POLLING_MS);
    } else {
        document.addEventListener('mouseout', (event) => {
            if (!event.toElement && !event.relatedTarget) {
                setTimeout(() => {
                    if (!checkIfExitModalShownCookieExists() 
                        && !sessionStorage?.getItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY) 
                        && exitModalWrapper.classList.contains('hide-me')
                    ) {
                        displayExitModal();
                    }
                }, DESKTOP_DELAY_MS);
            }
        });
    }
});

